import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Vant from "vant";
import "vant/lib/index.css";
import "./style/index.less";
import "lib-flexible";
import { GetParam } from "@/utils/getParam.js";

Vue.use(Vant);

import server from "@/api/index";
Vue.prototype.$server = server;

Vue.config.productionTip = false;

if (sessionStorage.getItem("miniApp_store")) {
  console.log(
    "vuex数据：",
    JSON.parse(sessionStorage.getItem("miniApp_store"))
  );
  store.replaceState(
    Object.assign(
      {},
      store.state,
      JSON.parse(sessionStorage.getItem("miniApp_store"))
    )
  );
}

//在页面刷新时将vuex里的信息保存到lsessionStorage里
window.addEventListener("beforeunload", () => {
  console.log(store.state);
  sessionStorage.setItem("miniApp_store", JSON.stringify(store.state));
});

// store.commit("user/SET_OPENID", "oa3DfwJmP0WF7TxkO667g8RG9QL8");
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  let appid = "wx93b2eb1658b9f547"; //实际公众号appid
  // let appid = "wx09aa7f8ad587001c";
  let redirect_uri = encodeURIComponent("http://yy.jxcvip.cn/#" + to.fullPath);
  console.log(to.path);
  const openid = store.state.user.openid;
  let url =
    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
    appid +
    "&redirect_uri=" +
    redirect_uri +
    "&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
  console.log("window.location.href", window.location.href);
  const ua = navigator.userAgent.toLowerCase();
  const isWeixin = ua.indexOf("micromessenger") != -1;
  if (!isWeixin) {
    window.location.href = url;
  }
  if (!openid) {
    let code = GetParam(window.location.href.split("#")[0], "code");
    console.log(code);
    if (!code) {
      window.location.href = url;
    } else {
      code = GetParam(window.location.href, "code");
      console.log("code", code);
      server.appointment.getWxUserInfoForWx({ code }).then(res => {
        console.log(res);
        if (res.code === "0") {
          console.log(123);
          store.commit("user/SET_OPENID", res.info.openid);
          console.log(store.state.user.openid);
          next();
        } else {
          // window.location.href = url;
        }
      });
    }
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
